import axios from 'axios';
import envs from '@/envs';
import store from '@/store';

const baseURL = process.env.NODE_ENV === 'development' ? envs.devUrlPanchok : envs.buildUrlPanchok;
// const baseURL =
// process.env.NODE_ENV === 'development' ? 'https://tbizpancapi.giftishow.com' : 'https://bizpancapi.giftishow.com';

const config = {
	baseURL,
	withCredentials: true,
};

const service = axios.create(config);

service.interceptors.request.use(
	config => {
		store.dispatch('loadingStart');

		return config;
	},
	error => {
		store.dispatch('loadingComplete');
		console.error('Request Interceptor Error', error);
	}
);

service.interceptors.response.use(
	response => {
		store.dispatch('loadingComplete');

		return response;
	},
	error => {
		store.dispatch('loadingComplete');
		console.error('Response Interceptor Error', error);
	}
);

export default service;
